export default "__VITE_ASSET__7bd209db__"